/**
 * Inline review carousel.
 *
 * One quote visible at a time; the arrows step through. The markup ships with
 * the first quote shown and the rest hidden, so with JS off the buy column
 * still carries a real review rather than an empty strip.
 *
 * Deliberately does not auto-advance. This sits a few centimetres from the buy
 * button, and copy that moves while someone is reading it is copy they stop
 * reading.
 */
(function () {
  "use strict";

  function init(root) {
    if (root.__calmyRev) return;
    root.__calmyRev = true;

    var items = [].slice.call(root.querySelectorAll("[data-calmy-revin-item]"));
    if (items.length < 2) {
      root.querySelectorAll("[data-calmy-revin-go]").forEach(function (b) { b.hidden = true; });
      return;
    }

    var i = 0;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (el, j) {
        el.hidden = j !== i;
        el.classList.toggle("is-on", j === i);
      });
    }

    root.querySelectorAll("[data-calmy-revin-go]").forEach(function (b) {
      b.addEventListener("click", function () {
        show(i + parseInt(b.getAttribute("data-calmy-revin-go"), 10));
      });
    });
  }

  function boot(root) { (root || document).querySelectorAll("[data-calmy-revin]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
